import React from "react";
import Hero from "./Hero";
import AboutEvent from "./AboutEvent";
import AboutFounder from "./AboutFounder";
import Benefits from "./Benefits";
import ConnectTo from "./ConnectTo";
import EventGallery from "./EventGallery";
import Origin from "./Origin";
import VisionMission from "./VisionMission";

const LandingPage = () => {
    return (
        <>
            <Hero />
            <ConnectTo />
            <AboutEvent />
            <Benefits />
            <AboutFounder />
            <VisionMission />
            <Origin />
            <EventGallery />
        </>
    );
};

export default LandingPage;
